<mat-card [ngClass]="type" [class.clickable]="clickable">
  <mat-card-content class="!flex flex-row gap-[20px] xs:gap-[8px] justify-start items-start">
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
